export const INT_TIPO_USUARIO_ADMINISTRADOR_WEB = 2;
export const INT_TIPO_SUB_USUARIO_WEB = 3;

export const INT_QUERY_UPDATE = 1;
export const INT_QUERY_DELETE = 0;

export const TIPO_USUARIO_WEB = { REGULAR: 1, SUPER_ADMIN: 2 };

export const INT_TIPO_USUARIO_MOVIL = { TRANSPORTADORA_SINDICATO: 7, USUARIO_SINGULAR: 8 };